<h3>Schedules</h3>
<div class="list-container">
                <item-list  [pLoading]="loading > 0" [pDataSource]="schedules">
                    <item-list-item class="schedule-item" *pItemListDef="let schedule" [pItem]="schedule" (click)="redirectToScheduleDetail(schedule.id)">
                        <stack pAlignment="center">
                            <span>
                                {{ schedule.location }}
                            </span>                        
                        </stack>
                    </item-list-item>
                </item-list>    
            </div>